// extracted by mini-css-extract-plugin
export default {"catalogByService":"c-j_gC"};